import React, { useState } from 'react';
//import styled from 'styled-components';
import Nav from './components/Nav.js';
import SocialMedia from './components/SocialMedia.js';
import useWindowSize from './components/useWindowSize';
import './App.css';

import {   
  About,
  Resume,
  Examples,
  Projects,
  Design,
  Credentials,
} from './components';

import gazebo from './assets/exampleImages/gazebo.png';
import tileEntryWay from './assets/exampleImages/tileEntryWay.png';
import garageOffice from './assets/exampleImages/garageOffice.png';
import frontBackDeckRestore from './assets/exampleImages/deckRestore.png';
import exteriorPathways from './assets/exampleImages/exteriorPathways.png';

import placeholder from './assets/placeholder.png';
import shroom from './assets/shroom.png';
import rubikCubeInvert from './assets/rubikCubeInvert.png';
import myCircleLogo from './assets/myCircleLogo.png';


function App() {
const isMobile = useWindowSize().isMobile;

  const topBarStyle = {
    margin: '0',
    position: 'relative',
    backgroundColor: '#302e2e',
  }

  const pageContainerStyle = {
    position: 'relative',
    top: isMobile ? '2vh' : '1vh',
    left: isMobile ? '4vw' : '11vw',
    fontSize: isMobile ? '14px' : '16px',
    minHeight: '70vh',
    height: 'auto',
    width: isMobile ? '92vw' : '78vw',
    boxShadow: '0 30px 20px rgba(0, 0, 0, 0.7)',
    borderRadius: '16px',
    background: `radial-gradient(circle at 90% 5%, rgba(0, 0, 0, 1) 2%, transparent 95%) 90% 25%,
    radial-gradient(circle at 55% 5%, rgba(0, 0, 0, 0) 42%, rgba(0, 0, 0, .7) 90%) 25% 5%,
    radial-gradient(circle at 85% 55%, rgba(0, 0, 0, 0) 82%, rgba(0, 0, 0, .7) 90%) 5% 25%`,
  }

  /*const dropDownStyle = {
    margin:'5%'
  }*/

  const[activePage, setActivePage] = useState('about');

  const handleNavigation = (page) => {
    setActivePage(page);
  };

  const handleExampleSelection = (example) => {
    // Unused state removed to avoid ESLint warnings
  }

  const examples = [
    { 
      value:'gazebo', 
      label:'Gazebo',
      imageUrl: gazebo, 
      description:`this is the description for the Gazebo`,
      additionalInfo:`this is additional info for the Gezebo` 
    },
    { 
      value:'tile', 
      label:'Entry Way Tile',
      imageUrl: tileEntryWay, 
      description:`this is the description for the Tile Project`,
      additionalInfo:`this is additional info for the tile project` 
    },
    { 
      value:'garageOffice', 
      label:'Garage Remodel',
      imageUrl: garageOffice,
      description:`this is the description for the Garage Remodel Project`,
      additionalInfo:`this is additional info for the garage remodel` 
    },
    { 
      value:'deckRestore', 
      label:'Deck Restoration',
      imageUrl: frontBackDeckRestore, 
      description:`this is the description for the Deck Restoration Project`,
      additionalInfo:`this is additional info for the deck restoration project` 
    },
    { 
      value:'exteriorPathways', 
      label:'Exterior Pathways',
      imageUrl: exteriorPathways, 
      description:`this is the description for the thing`,
      additionalInfo:`this is additional info for the thing` 
    },
  ]

  const [selectedDesign, setSelectedDesign] = useState('');

    const handleDesignSelection = (design) => {
    setSelectedDesign(design);
  }

  const designs = [
    {
      value:'shroom', label:'placeholder', imageUrl:shroom, description:`placeholder position 1 description`, height:``, width:``, extension:``, fileSize:``
    },
    {
      value:'rubikCube', label:'placeholder', imageUrl:rubikCubeInvert, description:`placeholder position 2 description`, height:``, width:``, extension:``, fileSize:``
    },
    {
      value:'orderingLogo', label:'myCircleLogo', imageUrl:myCircleLogo, description:`fictional inventory bus logo`, height:``, width:``, extension:``, fileSize:``
    },
    {
      value:'placeholderCell4', label:'placeholder position 4', imageUrl:placeholder, description:`placeholder position 4 description`, height:``, width:``, extension:``, fileSize:``
    },
  ]


  
  const renderActivePage = () => {
    switch(activePage) {
      case 'About':        
        return <About />
      case 'Resume':        
        return <Resume />
      case 'DIY':
        return(         
          <Examples options={examples} onExampleSelected = {handleExampleSelection} />           
        )
      case 'Projects':
        return <Projects />
      case 'Design':
          return <Design 
          options={designs}
          onDesignSelected = {handleDesignSelection}
          selectedDesign = {selectedDesign}
            />
      case 'Credentials':
        return <Credentials />
      default:
        return <About />
    }
  };

  return (
    <div className="App">      
      <div style={topBarStyle}>
        <Nav onNavigate={handleNavigation}/>
        <SocialMedia />
      </div>
      <div className="pageContainer" style = {pageContainerStyle}>      
      {renderActivePage()}
    </div>
    </div>
  );
}

export default App;
